import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import warning from "@/assets/myaccount/warning.svg";

interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  handleDelete: (fid?: number) => void;
  type: string;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onOpenChange,
  handleDelete,
  type,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[500px] px-0 py-3">
        <DialogHeader className="pb-2 pl-4 border-b">
          <DialogTitle className="text-xl">Confirm Deletion</DialogTitle>
        </DialogHeader>
      
             <DialogDescription>
            <div className="flex flex-col items-center justify-center text-center px-6 py-4 space-y-4">
              <img src={warning} alt="Warning" className="w-20 h-20" />
              <p className="text-[#363636] text-[16px] leading-[24px] ">
                  Are you sure you want to delete this {type}?
                  <br />
               
                 This action cannot be
            undone.
              </p>
            </div>
          </DialogDescription>
        {/* Delete and Cancel Buttons */}
        <div className="flex justify-end gap-2 pr-4 border-t pt-2">
            <Button
            size="sm"
            onClick={() => {
              onOpenChange(false);
            }}
            className=" bg-gray-200 hover:bg-gray-300 text-black px-5"
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleDelete()}
            size="sm"
            className="bg-charcoal hover:bg-charcoal/90 text-white px-5"
          >
            Delete
          </Button>
        
        </div>
      </DialogContent>
    </Dialog>
    
    
  );
};

export default ConfirmDeleteDialog;
